import { combineReducers } from "redux";

export const types = {
  SET_SHOW_ACTIVE: "USER_ACTIVE/SET_SHOW_ACTIVE",
  SET_SHOW_ACTIVE_SUCCESS: "USER_ACTIVE/SET_SHOW_ACTIVE_SUCCESS",
};

const initialState = {
  uiState: {
    showActive: false,
    showAciveSuccess: false,
  },
};

export const actions = {
  setShowActive: (showActive) => {
    return {
      type: types.SET_SHOW_ACTIVE,
      showActive,
    };
  },
  setShowActiveSuccess: (showAciveSuccess) => {
    return {
      type: types.SET_SHOW_ACTIVE_SUCCESS,
      showAciveSuccess,
    };
  },
};
//激活框的ui样式数据
const uiStateData = (state = initialState.uiState, action) => {
  switch (action.type) {
    case types.SET_SHOW_ACTIVE:
      return { ...state, showActive: action.showActive };
    case types.SET_SHOW_ACTIVE_SUCCESS:
      return { ...state, showAciveSuccess: action.showAciveSuccess };
    default:
      return { ...state };
  }
};

const reducer = combineReducers({
  uiStateData,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/active.js